// extracted by mini-css-extract-plugin
export default {"root":"Page_root__rHfHk","content":"Page_content__cczZX","main":"Page_main__aYQ7O","noPadding":"Page_noPadding__q9OPT"};